module.exports = __webpack_public_path__ + "static/img/ent-61.7d05847.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-61.jpg
// module id = 00dk
// module chunks = 51